import React, { Component } from "react";
import { AiStatusOverlay } from "../../../components/AiStatusOverlay";
import { extractAiFlags } from "../../store/form.answer.extract";
class FileUploader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // helpTextValue: "",
      imageValue: [],
      aiFlags: {},
    };
  }
  componentDidMount() {
    // if (this.props.element.properties.answerLabel) {
    //   this.onLoadHelpText(this.props);
    // }
    this.onLoadImage(this.props);
  }

  // onLoadHelpText(props) {
  //   const answerLabel = props.element.properties.answerLabel;
  //   if (answerLabel) {
  //     this.setState({ helpTextValue: answerLabel });
  //   }
  // }

  onLoadImage(props) {
    if (props.element) {
      let answerJson =
        typeof props.element?.answer === "string"
          ? JSON.parse(props.element?.answer)
          : props.element?.answer;
      if (answerJson?.image) {
        this.setState({ imageValue: answerJson.image });
      }
      this.setState({ aiFlags: extractAiFlags(answerJson) });
    }
  }

  render() {
    return (
      <>
        <AiStatusOverlay
          imageList={this.state.imageValue}
          aiVerificationStatus={this.state.aiFlags.aiVerificationStatus}
          aiVerificationMessage={this.state.aiFlags.aiVerificationMessage}
        />
        {/* {this?.state?.helpTextValue && (
          <FormHelperText>{this.state.helpTextValue}</FormHelperText>
        )} */}
      </>
    );
  }
}
export default FileUploader;
